var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.4 5.686"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55 5.686c-.017 0-.034 0-.05-.002a.7.7 0 0 1-.518-.29l-1.85-2.57a.7.7 0 1 1 1.136-.818L2.63 3.897 6.197.213a.7.7 0 0 1 1.006.974l-4.15 4.286a.7.7 0 0 1-.503.213Z"
  })));
};
export default SvgCheckmark;